import type { ReactNode } from "react";
import type React from "react";
import { useState, useEffect } from "react";

import { StyledBackground } from "app/components/bgImage/StyledComponents";
import { AssetsService } from "app/services/AssetsService";
interface ImageConfig {
    maxWidth: number;
    imageUrl: string;
}

interface BackgroundImageProps {
    children?: ReactNode;
    images: ImageConfig[];
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({ children, images }) => {
    const [imageUrl, setImageUrl] = useState<string>("");

    useEffect(() => {
        const updateImage = () => {
            const matchedImage =
                images.find(({ maxWidth }) => window.innerWidth <= maxWidth) || images[images.length - 1];
            setImageUrl(matchedImage.imageUrl);
        };

        updateImage();
        window.addEventListener("resize", updateImage);

        return () => window.removeEventListener("resize", updateImage);
    }, [images]);

    return (
        <StyledBackground style={{ backgroundImage: `url(${AssetsService.assetUrl(imageUrl)})` }}>
            {children}
        </StyledBackground>
    );
};

export default BackgroundImage;
